module.exports = __webpack_public_path__ + "public/images/flags/Flag_of_the_United_Arab_Emirates.80d8706b925cdf46c0162ae83e983cfa.png";